<template>
  <div class="add-map">
    <div class="map-input">
      <input type="text" v-model="addrValue" id="map-input" />
      <div @click="searchGoogle()" v-if="isGoogle">
        <i class="el-icon-search"></i>
      </div>
      <div @click="getLocation()" v-else><i class="el-icon-search"></i></div>
    </div>
    <div class="get-paths" @click="getPaths()">{{$t('pages.operate.text78')}}</div>
    <div id="add-map"></div>
  </div>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      map: null,
      marker: null,
      isGoogle: false,
      addrValue: null,
      bermudaTriangle: null,
      polyEditor: null,
      center: {},
    };
  },
  props: ["cenetrLanLng", "paths", "openMap"],
  computed: {
    ...mapState(["regionList", "currentRegion"]),
  },
  mounted() {
    let that = this;
    this.initMap();
    let arr = this.regionList;
    if (arr[this.currentRegion].id != "cn") {
      this.setGoogleMarker(that.cenetrLanLng, that.paths);
    } else {
      if (this.paths.length > 0) {
        var polygonPath = [];
        for (let i in that.paths) {
          polygonPath.push(
            new AMap.LngLat(that.paths[i].lng, that.paths[i].lat)
          );
        }
        this.setMarker(that.cenetrLanLng, polygonPath);
      }
    }
  },
  methods: {
    //初始化地图
    initMap() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        this.initGoogleMap();
        this.isGoogle = true;
      } else {
        this.initCnMap();
        this.isGoogle = false;
      }
    },
    //初始化谷歌地图
    initGoogleMap() {
      let that = this;
      this.map = new google.maps.Map(document.getElementById("add-map"), {
        center: { lat: -34.397, lng: 150.644 },
        mapId: "1dac188ecae44d48",
        zoom: 12,
        mapTypeControl: false,
        disableDefaultUI: true,
      });
      that.map.addListener("click", (mapsMouseEvent) => {
        let paths = [];
        paths = [
          that.newPath(mapsMouseEvent.latLng, -200, 3000),
          that.newPath(mapsMouseEvent.latLng, -200, 1500),
          that.newPath(mapsMouseEvent.latLng, -200, -1500),
          that.newPath(mapsMouseEvent.latLng, -200, -3000),
        ];
        that.setGoogleMarker(
          {
            lat: mapsMouseEvent.latLng.lat(),
            lng: mapsMouseEvent.latLng.lng(),
          },
          paths
        );
      });
    },
    //设置谷歌地图点
    setGoogleMarker(e, paths) {
      let that = this;
      that.map.setCenter(e);
      that.map.setZoom(15);
      this.center = e;
      this.geocoder(e);
      if (that.marker) {
        that.marker.setMap(null);
      }
      if (that.bermudaTriangle) {
        that.bermudaTriangle.setMap(null);
      }
      that.marker = new google.maps.Marker({
        position: e,
        map: that.map,
      });

      that.bermudaTriangle = new google.maps.Polygon({
        editable: true,
        paths: paths,
        strokeColor: "#1890FF",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "rgba(24, 144, 255, 0.2)",
        fillOpacity: 0.35,
      });
      that.bermudaTriangle.setMap(that.map);
    },
    //谷歌地图获取围栏坐标
    newPath(path, left, right) {
      return google.maps.geometry.spherical.computeOffset(path, left, right);
    },
    //谷歌地图搜索服务
    searchGoogle() {
      let that = this;
      const request = {
        query: that.addrValue,
        fields: ["name", "geometry"],
      };
      let service = new google.maps.places.PlacesService(that.map);
      service.findPlaceFromQuery(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          let paths = [];
          paths = [
            that.newPath(results[0].geometry.location, -200, 3000),
            that.newPath(results[0].geometry.location, -200, 1500),
            that.newPath(results[0].geometry.location, -200, -1500),
            that.newPath(results[0].geometry.location, -200, -3000),
          ];
          that.setGoogleMarker(
            {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng(),
            },
            paths
          );
        }
      });
    },
    //谷歌地图获取围栏坐标集
    getPaths() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        let that = this;
        // console.log(that.bermudaTriangle.getPath());
        let arr1 = that.bermudaTriangle.getPath().xd;
        this.$emit("getFencePaths", { paths: arr1, center: that.center });
      } else {
        let that = this;
        let arr1 = this.polyEditor.bu[0];
        this.$emit("getFencePaths", { paths: arr1, center: that.center });
      }
    },
    //谷歌获取城市
    geocoder(latlng) {
      let that = this;
      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({ location: latlng })
        .then((response) => {
          if (response.results[0]) {
            let arr = response.results[1].address_components;
            for (let i in arr) {
              for (let j in arr[i].types) {
                if (
                  arr[i].types[j] == "administrative_area_level_2" ||
                  arr[i].types[j] == "locality"
                ) {
                  this.$emit("setCity", arr[i].long_name);
                }
              }
            }
          } else {
            this.$message.error(that.$t('pages.operate.text95'));
          }
        })
        .catch();
    },
    //初始化高德地图
    initCnMap() {
      let that = this;
      this.map = new AMap.Map("add-map", {
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
        zoom: 10,
        resizeEnable: true,
      });

      //为地图注册click事件获取鼠标点击出的经纬度坐标
      this.map.on("click", function (e) {
        let paths = [];
        paths = that.getBoundingBox(e.lnglat.lat, e.lnglat.lng, 500);
        var polygonPath = [];
        for (let i in paths) {
          let arr = paths[i].split(",");
          polygonPath.push(new AMap.LngLat(Number(arr[1]), Number(arr[0])));
        }
        // console.log(polygonPath);

        that.setMarker({ lng: e.lnglat.lng, lat: e.lnglat.lat }, polygonPath);
      });
    },
    //根据中心点获取周围四个点
    getBoundingBox(pLatitude, pLongitude, pDistanceInMeters) {
      if (typeof Number.prototype.toRad === "undefined") {
        Number.prototype.toRad = function () {
          return (this * Math.PI) / 180;
        };
      }
      var latRadian = pLatitude.toRad();
      var degLatKm = 110.574235;
      var degLongKm = 110.572833 * Math.cos(latRadian);
      var deltaLat = pDistanceInMeters / 1000.0 / degLatKm;
      var deltaLong = pDistanceInMeters / 1000.0 / degLongKm;

      var topLat = pLatitude + deltaLat;
      var bottomLat = pLatitude - deltaLat;
      var leftLng = pLongitude - deltaLong;
      var rightLng = pLongitude + deltaLong;

      var northWestCoords = topLat + "," + leftLng;
      var northEastCoords = topLat + "," + rightLng;
      var southWestCoords = bottomLat + "," + leftLng;
      var southEastCoords = bottomLat + "," + rightLng;

      var boundingBox = [
        northWestCoords,
        northEastCoords,
        southEastCoords,
        southWestCoords,
      ];

      return boundingBox;
    },
    //高德地图设置点
    setMarker(e, paths) {
      let that = this;
      this.center = e;
      this.getCnMapCity([e.lng, e.lat]);
      if (that.marker) {
        that.marker.setMap(null);
        that.marker = null;
      }
      if (that.bermudaTriangle) {
        this.map.remove(that.bermudaTriangle);
        that.bermudaTriangle = null;
      }
      if (that.polyEditor) {
        that.polyEditor.close();
        that.polyEditor = null;
      }
      that.marker = new AMap.Marker({
        icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [e.lng, e.lat],
      });
      this.bermudaTriangle = new AMap.Polygon({
        path: paths,
        fillColor: "rgba(24, 144, 255, 0.2)", // 多边形填充颜色
        borderWeight: 2, // 线条宽度，默认为 1
        strokeColor: "#1890FF", // 线条颜色
      });
      this.map.add(that.bermudaTriangle);
      this.polyEditor = new AMap.PolyEditor(that.map, that.bermudaTriangle);
      this.polyEditor.open();
      that.marker.setMap(that.map);
      this.map.setZoomAndCenter(15, [e.lng, e.lat]);
    },
    //高德搜索位置
    getLocation() {
      let that = this;
      AMap.service(["AMap.PlaceSearch"], function () {
        var placeSearch = new AMap.PlaceSearch();
        placeSearch.search(that.addrValue, function (status, result) {
          if (status == "complete" && result.info == "OK") {
            let paths = that.getBoundingBox(
              result.poiList.pois[0].location.lat,
              result.poiList.pois[0].location.lng,
              800
            );
            var polygonPath = [];
            for (let i in paths) {
              let arr = paths[i].split(",");
              polygonPath.push(new AMap.LngLat(Number(arr[1]), Number(arr[0])));
            }
            that.setMarker(
              {
                lng: result.poiList.pois[0].location.lng,
                lat: result.poiList.pois[0].location.lat,
              },
              polygonPath
            );
            that.addrValue = "";
          } else {
            that.$message({
              message: that.$t('pages.operate.text96'),
              type: "warning",
            });
          }
        });
      });
    },
    //高德地图获取城市
    getCnMapCity(e) {
      let that = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "010",
        });

        var lnglat = e;

        geocoder.getAddress(lnglat, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            that.$emit(
              "setCity",
              result.regeocode.addressComponent.city ||
                result.regeocode.addressComponent.province
            );
          }
        });
      });
    },
  },
};
</script>


<style scoped>
#add-map {
  width: 100%;
  height: 100%;
}
.add-map {
  width: 100%;
  height: 100%;
  position: relative;
}
.get-paths {
  width: 120px;
  height: 46px;
  background-color: #4c7cd6;
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 22;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgb(114 124 245 / 50%);
  text-align: center;
  line-height: 46px;
  color: #fff;
  cursor: pointer;
}
.map-input {
  width: 260px;
  height: 46px;
  background-color: #fff;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 22;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgb(114 124 245 / 50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  box-sizing: border-box;
}
.map-input input {
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;
}
.map-input div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  height: 100%;
  border-left: 1px solid #dfdfdf;
  cursor: pointer;
}
.map-input div i {
  font-size: 24px;
}
</style>